export const MODEL_KEY = {
  ID: 'id',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  CLASS_NAME: 'className', // Set by Sequelize with `paranoid` mode set to true
  DELETED_AT: 'deletedAt'
}

export const MODEL_KEYS = Object.values(MODEL_KEY)

export const AUDIT_KEY = {
  DATA: 'data',
  EVENT: 'event',
  IP: 'ip',
  COUNTRY: 'country',
  PROFILE_ID: 'profileId',
  USER_ID: 'userId'
}
